import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { EventStreamListener } from '@/app/event-stream';
import { SectionStateStoreModule, SectionStateStoreModuleSymbol,  } from './section-state-store-module';
import { SectionStatusChangedEvent, SectionStatusEvent } from '../statistics/events/section-status-events';
import { NavigationEvent, SectionClosedEvent } from '../statistics/events/navigation-events';

const debug = Debug('section-state-projection');

export const SectionStateProjectionSymbol = Symbol.for('SectionStateProjection');

@injectable()
export class SectionStateProjection implements EventStreamListener {

  public events: 'all' = 'all';

  constructor(
    @inject(SectionStateStoreModuleSymbol)
    private store: SectionStateStoreModule) {

  }

  public handle(event: NavigationEvent | SectionStatusEvent) {
    switch (event.name) {
      case 'section-closed':
        this.handleSectionClosed(event.payload);
        return true;
      case 'section-status-changed':
        this.handleSectionStatusChanged(event.payload);
        return true;
    }

    return false;
  }

  private handleSectionStatusChanged(event: SectionStatusChangedEvent) {
    debug('handle section-status-changed', event.progress, event.progress.status);

    this.store.changeStatus({ id: event.sectionId, status: event.progress.status });
  }

  private async handleSectionClosed(event: SectionClosedEvent) {

    debug('handle section-closed', event.sectionId, event.durationSeconds);

    this.store.addDuration({ id: event.sectionId, durationSeconds: event.durationSeconds });
  }
}
